import type { QueryClient } from "@tanstack/react-query";
import * as React from "react";
import type { RouteObject } from "react-router-dom";

import { Spinner } from "@/components/atoms/Spinner/Spinner";
import { ProtectedRoutes } from "@/features/auth";

import { commonRoutes } from "./shared";

export const protectedRoutes: (queryClient: QueryClient) => RouteObject[] = (
  queryClient: QueryClient
) => [
  {
    element: (
      <React.Suspense
        fallback={
          <div className="fixed inset-0 grid place-content-center bg-white">
            <Spinner className="size-5 text-primary" />
          </div>
        }
      >
        <ProtectedRoutes />
      </React.Suspense>
    ),
    children: commonRoutes(queryClient),
  },
];
